import { getBaseChatPath } from '../../contracts/projects/chat-home-path';
import { injected } from '../injected-auth';

/**
 * Work home is gated purely on the Projects flag. Evidence entitlement
 * (NHS contact-sales / disclaimer / no-access) gates the Evidence *surface*,
 * not whether a Projects-enabled user can reach Work — so it is deliberately
 * not consulted here. The surface-level gate lives in
 * `useEvidenceChatSurfaceGate` and applies inside the Evidence experience.
 */
export const useCanUseWorkHome = (): boolean => injected('useIsHeidiWorkEnabled')();

export const useBaseChatHref = (): string => getBaseChatPath(useCanUseWorkHome());
